import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FacettenUrlService } from '../../services/facetten/facetten.url.service';

import { AnbieterUrlService } from '../../services/facetten/instance/anbieterurl.service';
import { BarrierefreiheitUrlService } from '../../services/facetten/instance/barrierefreiheiturl.service';
import { BeginnterminUrlService } from '../../services/facetten/instance/beginnterminurl.service';
import { DauerUrlService } from '../../services/facetten/instance/dauerurl.service';
import { FoerderartUrlService } from '../../services/facetten/instance/foerderarturl.service';
import { KostenUrlService } from '../../services/facetten/instance/kostenurl.service';
import { DigitaleLernformService } from '../../services/facetten/instance/lernformen-facetten/digitalelernform.service';
import { FernLernformService } from '../../services/facetten/instance/lernformen-facetten/fernlernform.service';
import { KombiLernformService } from '../../services/facetten/instance/lernformen-facetten/kombilernform.service';
import { LernformFacettenService } from '../../services/facetten/instance/lernformen-facetten/lernformfacetten.service';
import { LernformUrlService } from '../../services/facetten/instance/lernformen-facetten/lernformurl.service';
import { VorortLernformService } from '../../services/facetten/instance/lernformen-facetten/vorortlernform.service';
import { RegionenUrlService } from '../../services/facetten/instance/regionenurl.service';
import { UnterrichtszeitUrlService } from '../../services/facetten/instance/unterrichtszeiturl.service';
import { WeiterbildungsartUrlService } from '../../services/facetten/instance/weiterbildungsarturl.service';
import { CleanupService } from '../../shared/utils/cleanup.service';
import { ModalPopupComponent } from '../modal/modal-popup/modal-popup.component';
import { AnbieterFacetteComponent } from './anbieter-facette/anbieter-facette.component';
import { BarrierefreiheitFacetteComponent } from './barrierefreiheit-facette/barrierefreiheit-facette.component';
import { BeginnterminFacetteComponent } from './beginntermin-facette/beginntermin-facette.component';
import { DauerFacetteComponent } from './dauer-facette/dauer-facette.component';
import { ErweiterteSucheToggleComponent } from './erweiterte-suche-toggle/erweiterte-suche-toggle.component';

import { FacettenComponent } from './facetten.component';
import { FilterZuruecksetzenComponent } from './filter-zuruecksetzen/filter-zuruecksetzen.component';
import { FoerderartFacetteComponent } from './foerderart-facette/foerderart-facette.component';
import { KostenFacetteComponent } from './kosten-facette/kosten-facette.component';
import { OrtFacetteComponent } from './ort-facette/ort-facette.component';
import { UmkreisFacetteComponent } from './umkreis-facette/umkreis-facette.component';
import { DigitaleLernformFacetteComponent } from './unterrichtsform-facette/digitale-lernform-facette/digitale-lernform-facette.component';
import { FernunterrichtFacetteComponent } from './unterrichtsform-facette/fernunterricht-facette/fernunterricht-facette.component';
import { KombinierteLernformFacetteComponent } from './unterrichtsform-facette/kombinierte-lernform-facette/kombinierte-lernform-facette.component';
import { UnterrichtsformFacetteComponent } from './unterrichtsform-facette/unterrichtsform-facette.component';
import { VorortFacetteComponent } from './unterrichtsform-facette/vorort-facette/vorort-facette.component';
import { UnterrichtszeitFacetteComponent } from './unterrichtszeit-facette/unterrichtszeit-facette.component';
import { WeiterbildungsartFacetteComponent } from './weiterbildungsart-facette/weiterbildungsart-facette.component';

@NgModule({
  imports: [
    CommonModule,
    FilterZuruecksetzenComponent,
    BeginnterminFacetteComponent,
    ErweiterteSucheToggleComponent,
    UnterrichtszeitFacetteComponent,
    UnterrichtsformFacetteComponent,
    DauerFacetteComponent,
    VorortFacetteComponent,
    FernunterrichtFacetteComponent,
    DigitaleLernformFacetteComponent,
    KombinierteLernformFacetteComponent,
    AnbieterFacetteComponent,
    ModalPopupComponent,
    WeiterbildungsartFacetteComponent,
    KostenFacetteComponent,
    BarrierefreiheitFacetteComponent,
    FoerderartFacetteComponent,
    OrtFacetteComponent,
    UmkreisFacetteComponent,
    FacettenComponent
  ],
  exports: [FacettenComponent],
  providers: [
    { provide: CleanupService },
    { provide: FacettenUrlService, multi: true, useExisting: LernformUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: UnterrichtszeitUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: BeginnterminUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: RegionenUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: DauerUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: AnbieterUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: WeiterbildungsartUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: KostenUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: FoerderartUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: KostenUrlService },
    { provide: FacettenUrlService, multi: true, useExisting: BarrierefreiheitUrlService },
    { provide: LernformFacettenService, multi: true, useExisting: KombiLernformService },
    { provide: LernformFacettenService, multi: true, useExisting: FernLernformService },
    { provide: LernformFacettenService, multi: true, useExisting: DigitaleLernformService },
    { provide: LernformFacettenService, multi: true, useExisting: VorortLernformService }
  ]
})
export class FilterModule {}
